/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Elevenlabs_Model_LabelInputs */



/**
* | output |
* | --- |
* | "ElevenLabs model" |
*
* @param {Event_Ad_Elevenlabs_Model_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_elevenlabs_model_label = /** @type {((inputs?: Event_Ad_Elevenlabs_Model_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Elevenlabs_Model_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modèle ElevenLabs")
	if (locale === "de") return /** @type {LocalizedString} */ ("ElevenLabs-Modell")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modello ElevenLabs")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Модель ElevenLabs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modelo de ElevenLabs")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ElevenLabs 模型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ElevenLabs モデル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ElevenLabs मॉडल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelo ElevenLabs")
	return /** @type {LocalizedString} */ ("ElevenLabs model")
});